import type { Effect, Reducer } from "@umijs/max";
import { getEnumConfig } from "@/api/user";
import type { EnumConfigResult } from "@/api/user/types";

export interface EnumModelState {
    paperType: EnumConfigResult["data"];
    fetchedPaperType: boolean;
}

export interface EnumModelType {
    namespace: "enum";
    state: EnumModelState;
    effects: {
        fetchPaperType: Effect;
    };
    reducers: {
        savePaperType: Reducer<EnumModelState>;
    };
}

const EnumModel: EnumModelType = {
    namespace: "enum",
    state: {
        paperType: [],
        fetchedPaperType: false,
    },
    effects: {
        *fetchPaperType(_, { call, put, select }) {
            const fetched: boolean = yield select(
                (state: { enum: EnumModelState }) => state?.enum?.fetchedPaperType
            );
            if (fetched) {
                return;
            }
            const response: EnumConfigResult = yield call(getEnumConfig, {
                collectName: "paperType",
            });
            if (response?.success && response.data) {
                const formalData = response.data.map((item) => {
                    return {
                        label: item.enumName,
                        value: item.enumValue
                    }
                })
                yield put({
                    type: "savePaperType",
                    payload: formalData,
                });
            }
        },
    },
    reducers: {
        savePaperType(state, { payload }) {
            return {
                ...state,
                paperType: payload || [],
                fetchedPaperType: true,
            };
        },
    },
};

export default EnumModel;

